import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactNode;
}

// Overlays live directly under <body>. Rendered inside the page tree a
// `position: fixed` box gets trapped by any ancestor with transform/filter/
// overflow or its own stacking context, and then the dialog is off-screen.
export const ModalPortal: React.FC<Props> = ({ children }) => {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(children, document.body);
};

export default ModalPortal;
